import Common from '../../../../Common';

const Callers = class extends Common {
	async read(queueId: id, wallboardToken?: string) {
		if(wallboardToken) {
			return this.getNoHeaders(`/user/wallboard/queue/caller/${queueId}?wallboard_token=${wallboardToken}`);
		}else {
			return this.get(`/user/wallboard/queue/caller/${queueId}`)
		}
	}
}

export default Callers
